import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import Routes from '../../routes';
import { selectPeriod, selectConnection } from '../../shared/store/actions';
import { SPECIAL_TYPE_TOGGLE_MORE } from '../../dashboard/constants';

class ConnectionRunStatusLinkRenderer extends PureComponent {
  static propTypes = {
    value: PropTypes.string.isRequired,
    period: PropTypes.shape({
      name: PropTypes.string.isRequired,
    }).isRequired,
    selectConnection: PropTypes.func.isRequired,
    selectPeriod: PropTypes.func.isRequired,
    history: PropTypes.shape({
      push: PropTypes.func.isRequired,
    }).isRequired,
    data: PropTypes.oneOfType([
      PropTypes.shape({
        connectionName: PropTypes.string.isRequired,
      }).isRequired,
      PropTypes.shape({
        type: PropTypes.string.isRequired,
        onClick: PropTypes.func.isRequired,
      }).isRequired,
    ]),
  };

  navigateToConnectionRunStatus = () => {
    const {
      period,
      selectConnection,
      selectPeriod,
      value,
      history,
    } = this.props;

    selectConnection(value);
    selectPeriod(period);
    history.push(Routes.dashboard.CONNECTION_RUN_STATUS);
  };

  render() {
    const { value, data } = this.props;

    if (data.type === SPECIAL_TYPE_TOGGLE_MORE) {
      return (
        <button
          className="widget-link-renderer btn btn-link"
          onClick={(data.onClick)}
          type="button"
        >
          {value}
        </button>
      );
    }

    return (
      <button className="btn btn-link ag-link-renderer grid-link" onClick={this.navigateToConnectionRunStatus}>
        {value}
      </button>
    );
  }
}

export default connect(
  ({ shared }) => ({
    period: shared.period,
  }),
  {
    selectPeriod,
    selectConnection,
  }
)(withRouter(ConnectionRunStatusLinkRenderer));
